exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit2a .structure{margin:20px -50px 0}.unit2a .highlight-answer p span{color:#be390a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/modules/courses/2/2a/ideasFitTogether/ideasFitTogether.scss
// module id = 649
// module chunks = 0